import React from "react"

import BaseSvgIcon from "../Base"

const MedicalFill = (props) => (
  <BaseSvgIcon {...props} viewBox="0 0 44 44">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M28.0299 7.26988C28.0299 6.36988 27.2999 5.62988 26.3899 5.62988H17.6099C16.7099 5.62988 15.9699 6.35988 15.9699 7.26988V15.9699H7.26988C6.36988 15.9699 5.62988 16.6999 5.62988 17.6099V26.3899C5.62988 27.2899 6.35988 28.0299 7.26988 28.0299H15.9699V36.7299C15.9699 37.6299 16.6999 38.3699 17.6099 38.3699H26.3899C27.2899 38.3699 28.0299 37.6399 28.0299 36.7299V28.0299H36.7299C37.6299 28.0299 38.3699 27.2999 38.3699 26.3899V17.6099C38.3699 16.7099 37.6399 15.9699 36.7299 15.9699H28.0299V7.26988Z"
      fill="#000"
    />
  </BaseSvgIcon>
)

export default MedicalFill
